import React from 'react';
// import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { bounceIn, zoomIn } from 'react-animations';
import styled, { keyframes } from 'styled-components';
import Header from './Header';
import { errorMessagesCopy } from '../utilities/error-messages';

const bounceAnimation = keyframes`${bounceIn}`;
const zoomAnimation = keyframes`${zoomIn}`;

const BouncyDiv = styled.div`
  animation: 1s ${bounceAnimation};
`;

const ZoomInDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

  const MainTain = props => {
    const errorCode =  useSelector(state => state.account.serverStatus.code);

    return (
      <div className="ReportHome">
        <Header />
        <main>
          <ZoomInDiv  className="error_code">
          {errorCode !== 200
           ? errorCode
           : 'Sorry'}
          </ZoomInDiv>

          <BouncyDiv className="error_message">
            <span>
            { errorCode !== 200
             ? errorMessagesCopy(errorCode)
             : `We don't currently support the browser or device that you are using. For the optimal experience we recommend using Chrome on a desktop device.`}
            </span>
          </BouncyDiv>
        </main>
      </div>
    )

}

export default MainTain;


